import { Box, withStyles } from '@material-ui/core';

export const IconContainer = withStyles(({ palette }) => ({
  root: {
    width: 40,
    height: 40,
    backgroundColor: palette.error.main,
    borderRadius: 120,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
  }
}))(Box);
